import React, { useState, useCallback } from 'react'
import { createRoot } from 'react-dom/client'
import Modal from './index'
import { Card, Stack } from '@mui/material'
import Button from '@/components/Button'
import { styled } from '@mui/material/styles'
import Text from '@/components/Text'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import theme from '@/theme'
import ClearIcon from '@mui/icons-material/Clear'
import { CopyToClipboard } from 'react-copy-to-clipboard'
export interface BasicModalProps {
  title?: string;
  width?: string | number;
  content?: string | React.ReactElement;
  cancelText?: string;
  okText?: string;
  onClose: () => void;
  onConfirm?: () => void;
  closeAfterClose?: boolean;
  clipboard?: { text: string; onCopy: () => void };
  hideClose?: boolean;
}

export const ModalContent = styled(Card)(() => ({
  boxShadow: 'none',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}))

export const ModalFooter = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '16px',
}))

export const Row = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}))

export const BasicModal: React.FC<BasicModalProps> = (props) => {
  const {
    title,
    content,
    onClose,
    cancelText,
    onConfirm,
    okText,
    closeAfterClose,
    clipboard,
    width,
    hideClose,
  } = props
  const [open, setOpen] = useState<boolean>(true)

  const handleClose = useCallback(() => {
    onClose()
    setOpen(false)
  }, [onClose])

  const handleOk = useCallback(() => {
    onConfirm && onConfirm()
    closeAfterClose && setOpen(false)
  }, [closeAfterClose, onConfirm])

  return (
    <Modal width={width ?? 500} open={open} onClose={handleClose}>
      <ModalContent sx={{ minHeight: '200px' }}>
        <Row>
          {title ? <Text weight="bold">{title}</Text> : <div />}
          {!hideClose && (
            <ClearIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
          )}
        </Row>
        <Stack sx={{ flex: 1, justifyContent: 'center' }}>
          {typeof content === 'string' ? (
            <Text size="xs" weight="regular">
              {content}
            </Text>
          ) : (
            content
          )}
        </Stack>

        <ModalFooter sx={{ marginTop: 'auto' }}>
          {!hideClose && (
            <Button type="text" onClick={handleClose}>
              {cancelText ?? '取消'}
            </Button>
          )}
          {clipboard ? (
            <CopyToClipboard text={clipboard?.text} onCopy={clipboard?.onCopy}>
              <Button type="highlight" onClick={handleOk}>
                复制并关闭
              </Button>
            </CopyToClipboard>
          ) : (
            <Button type="highlight" onClick={handleOk}>
              {okText ?? '确定'}
            </Button>
          )}
          {/* {onConfirm && 
            (okButton ? {React.cloneElement(okButton, {onClick:handleOk})} :
            <Button variant="contained" onClick={handleOk}>
              {okText ?? "确定"}
            </Button>}} */}
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export const confirm = (config: BasicModalProps) => {
  const modalDom = document.createElement('div')
  const container = document.getElementById('root')
   // @ts-ignore
  container.appendChild(modalDom)
  modalDom.id = 'modal-window'
  modalDom.style.zIndex = '-2'
  const modalRoot = createRoot(modalDom)

  const handleRemoveModal = () => {
    config.onClose && config.onClose()
    setTimeout(() => {
      modalDom.remove()
    }, 3000)
  }

  modalRoot.render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/*eslint-disable-next-line react/jsx-no-bind*/}
      <BasicModal {...config} onClose={handleRemoveModal} />
    </ThemeProvider>
  )
}
